
// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const BASE_URL = "https://ecom.cyberathon.com/";

// function TeamAPI() {
//   const [teamList, setTeamList] = useState([]);

//   useEffect(() => {
//     const fetchTeam = async () => {
//       try {
//         const res = await axios.get(
//           BASE_URL + "index.php/Hijama/list_team_members"
//         );
//         setTeamList(res.data.data || []);
//       } catch (error) {
//         console.error("Error fetching team:", error);
//       }
//     };

//     fetchTeam();
//   }, []);

//   return (
//     <div className="container-fluid px-5">
//       <div className="col-12 col-md-2 pt-5">
//         <h4 className="text-dark fs-2"><b>Team</b></h4>
//       </div>

//       <div className="row text-center pt-5">
//         <h1>The Heart of Our Pharmacy</h1>
//         <p className="text-muted">
//           Libero diam auctor tristique hendrerit in eu vel id.
//           <br />Nec leo amet suscipit nulla. Nullam vitae sit tempus diam.
//         </p>
//       </div>

//       <div className="row justify-content-center gap-3 pt-4">

//         {teamList.map((member) => (
//           <div
//             key={member.id}
//             className="col-12 col-sm-6 col-md-4 col-lg-3 text-center mb-4"
//           >
//             <img
//               src={BASE_URL + member.image}
//               alt={member.name}
//               className="img-fluid rounded"
//               style={{
//                 height: "240px",
//                 width: "100%",
//                 objectFit: "cover",
//                 borderRadius: "10px",
//               }}
//             />

//             <h4 className="pt-3 fw-semibold">{member.name}</h4>

//             <p className="text-muted">Work Experience - {member.experience} years</p>
//           </div>
//         ))}

//       </div>
//     </div>
//   );
// }

// export default TeamAPI;



import React, { useEffect, useState } from "react";
import axios from "axios";

const BASE_URL = "https://ecom.cyberathon.com/";

function TeamAPI() {
  const [teamList, setTeamList] = useState([]);
  const [heading, setHeading] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const res = await axios.get(
          BASE_URL + "index.php/Hijama/list_team_members"
        );
        const data = res.data.data || [];
        setTeamList(res.data.data || []);
        if(data.length > 0){
          setHeading(data[0].heading);
          setDescription(data[0].description);
        } 
      } catch (error) {
        console.error("Error fetching team:", error);
      }
    };

    fetchTeam();
  }, []);

  return (
    <div className="container-fluid px-5">
      <div className="col-12 col-md-2 pt-5">
        <h4 className="text-dark fs-2"><b>Team</b></h4>
      </div>

      <div className="row pt-5 px-4">
        <h1>{heading}</h1>
        <p>
{description}
        </p>
      </div>

      {/* <div className="row justify-content-between gap-3 pt-4"> */}
      <div className="row g-5 pt-4">

        {teamList.map((member) => (
          <div
            key={member.id}
            className="col-12 col-sm-6 col-md-4 col-lg-4 text-center mb-4"
          >
            {/* <img
              src={BASE_URL + member.image}
              alt={member.name}
              className="imeg"
              style={{
                // height: "240px",
                // width: "100%",
                objectFit: "cover",
              }}
            /> */}

            {member.image && member.image !== "null" && (
  <img
    src={BASE_URL + member.image}
    alt=""
    className="imeg"
    style={{ objectFit: "cover" }}
  />
)}

{ member.name &&
  ( <h4 className="pt-3 fw-semibold">{member.name}</h4>)
}
           
{ member.experience &&
  (
                <p className="text-muted">Work Experience - {member.experience} years</p>

  )
}
            {/* <p className="text-muted">Work Experience - {member.experience} years</p> */}
          </div>
        ))}

      </div>
    </div>
  );
}

export default TeamAPI;

